import { useQuery } from 'react-query'

import {
  CustomField,
  type CustomFieldConstructorData,
} from '@webapp/core/entities/internal/CustomField'
import { customFieldQueryConfig } from '@webapp/core/query-configs/customField'
import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'

const toCustomFields = (
  response: RepoPaginatedResponse<CustomFieldConstructorData>
) =>
  response.data.map(
    (customFieldConstructorData) => new CustomField(customFieldConstructorData)
  )

/**
 * Every line-item custom field in one page, for a select. No
 * `meta__is_active` filter is sent, so fields that are no longer active are
 * included — a budget may still be scoped to one.
 */
export const useQueryAllOrderItemCustomFields = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { data, isLoading, isFetching, isError, error } = useQuery({
    ...customFieldQueryConfig.getOrderItemList({ page_size: 'all' }),
    select: toCustomFields,
    enabled,
  })

  return {
    customFields: data ?? [],
    isLoading: isLoading && !data,
    isFetching,
    isError,
    error,
  }
}
